<div
  class="main-container"
  [class.white-rounded-container]="displayWithRoundContainer"
  style="overflow: auto; position: relative; margin-top: 0px">
  <div class="svg-wave-container">
    <img *ngIf="displaySidenavSvg" style="width: 400px" src="/assets/sharedSpaAssets/icons_shared/sidenav-top-menu.svg" />
  </div>
  <div class="summary-content">
    <div class="summary-title">
      {{ summaryTitle }}
    </div>
    <div
      *ngIf="summaryListItem.length > 0"
      class="white-list-array-d4"
      style="margin-top: -15px"
      [class.summary-list-container]="displaySidenavSvg">
      <ul class="list-d4-ul" style="background-color: transparent !important">
        <ng-container *ngFor="let sumarryItem of summaryListItem; let i = index">
          <ng-container *ngIf="sumarryItem.visibility != false">
            <li class="list-d4-li">
              <span class="left-item">
                {{ sumarryItem.name }}
              </span>
              <ng-container [ngSwitch]="sumarryItem.type">
                <span *ngSwitchCase="'string'" class="right-item" [class.si-italic]="sumarryItem.style == 'italic'">
                  <ng-container *ngIf="sumarryItem.readOnly == true">
                    {{ sumarryItem.value }}
                  </ng-container>
                </span>
                <span *ngSwitchCase="'textArea'" class="right-item" [class.si-italic]="sumarryItem.style == 'italic'">
                  <ng-container *ngIf="sumarryItem.readOnly == true">
                    {{ sumarryItem.value }}
                  </ng-container>
                </span>
                <span *ngSwitchCase="'html'" class="right-item" [class.si-italic]="sumarryItem.style == 'italic'">
                  <ng-container *ngIf="sumarryItem.readOnly == true">
                    {{ sumarryItem.value }}
                  </ng-container>
                </span>
                <span *ngSwitchCase="'checkBox'" class="right-item" [class.si-italic]="sumarryItem.style == 'italic'">
                  <ng-container *ngIf="sumarryItem.readOnly == true">
                    <mat-checkbox [checked]="sumarryItem.value"></mat-checkbox>
                  </ng-container>
                </span>
                <span *ngSwitchCase="'number'" class="right-item" [class.si-italic]="sumarryItem.style == 'italic'">
                  <ng-container *ngIf="sumarryItem.readOnly == true">
                    {{ sumarryItem.value }}
                  </ng-container>
                </span>
                <span *ngSwitchCase="'phone'" class="right-item" [class.si-italic]="sumarryItem.style == 'italic'">
                  <ng-container *ngIf="sumarryItem.readOnly == true">
                    {{ sumarryItem.value }}
                  </ng-container>
                </span>
                <span *ngSwitchCase="'currency'" class="right-item" [class.si-italic]="sumarryItem.style == 'italic'">
                  <ng-container *ngIf="sumarryItem.readOnly == true">
                    {{ sumarryItem.value | currency: "EUR" }}
                  </ng-container>
                </span>
                <span *ngSwitchCase="'date'" class="right-item" [class.si-italic]="sumarryItem.style == 'italic'">
                  <ng-container *ngIf="sumarryItem.readOnly == true">
                    {{ sumarryItem.value | date: "shortDate" }}
                  </ng-container>
                </span>
                <span *ngSwitchCase="'dateTime'" class="right-item" [class.si-italic]="sumarryItem.style == 'italic'">
                  <ng-container *ngIf="sumarryItem.readOnly == true">
                    {{ sumarryItem.value | date }}
                  </ng-container>
                </span>
                <span *ngSwitchCase="'duration'" class="right-item" [class.si-italic]="sumarryItem.style == 'italic'">
                  <ng-container *ngIf="sumarryItem.readOnly == true">
                    {{ sumarryItem.value }}
                  </ng-container>
                </span>
                <span *ngSwitchCase="'img'" class="right-item" [class.si-italic]="sumarryItem.style == 'italic'">
                  <ng-container *ngIf="sumarryItem.readOnly == true">
                    <img style="width: 40px" [src]="sumarryItem.value" />
                  </ng-container>
                </span>
                <span *ngSwitchCase="'decimal'" class="right-item" [class.si-italic]="sumarryItem.style == 'italic'">
                  <ng-container *ngIf="sumarryItem.readOnly == true">
                    {{ sumarryItem.value | number: "1.2-2" }}
                  </ng-container>
                </span>
                <span *ngSwitchCase="'link'" class="right-item" [class.si-italic]="sumarryItem.style == 'italic'">
                  <ng-container *ngIf="sumarryItem.readOnly == true">
                    <a [href]="sumarryItem.value">sumarryItem.value</a>
                  </ng-container>
                </span>
              </ng-container>
            </li>
          </ng-container>
        </ng-container>
      </ul>
    </div>
    <div *ngIf="summaryListItem == undefined || summaryListItem.length == 0">
      {{ summaryErrorText }}
    </div>
  </div>
</div>
